module.exports = __webpack_public_path__ + "assets/img/creation_icon_b.cabf8c2d.png";